export default __webpack_public_path__ + "static/media/linkedin.82e81616.svg";